import React from "react";
import styles from "./PeopleUI.module.css";
import ui from "../DashboardUI.module.css";

export default function PeopleToolbar({
  searchQuery,
  onSearchChange,
  viewMode,
  onViewModeChange,
  showArchivedResources,
  onToggleArchived,
  canViewResources,
}) {
  return (
    <div className={styles.toolbar}>
      <div className={styles.searchWrap}>
        <span className={styles.searchIcon} aria-hidden="true">⌕</span>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Search people & resources..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Search people and resources"
        />
      </div>

      <div className={styles.toolbarSpacer} />

      {canViewResources && (
        <label className={styles.archivedToggle}>
          <input
            type="checkbox"
            checked={showArchivedResources}
            onChange={(e) => onToggleArchived(e.target.checked)}
          />
          Show archived
        </label>
      )}

      <div className={ui.viewToggleGroup} role="group" aria-label="View mode">
        <button
          type="button"
          className={`${ui.viewToggleButton} ${viewMode === "grid" ? ui.viewToggleButtonActive : ""}`}
          onClick={() => onViewModeChange("grid")}
          aria-pressed={viewMode === "grid"}
        >
          Grid
        </button>
        <button
          type="button"
          className={`${ui.viewToggleButton} ${viewMode === "list" ? ui.viewToggleButtonActive : ""}`}
          onClick={() => onViewModeChange("list")}
          aria-pressed={viewMode === "list"}
        >
          List
        </button>
      </div>
    </div>
  );
}
